import TournamentParticipantItem from "./TournamentParticipantItem";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

function TournamentParticipants() {
    const {t} = useTranslation();
    const {sideBarTournamentId ,list} = useSelector(state => state.tournament);
    const selectedTournament = list[sideBarTournamentId];
    const participants = selectedTournament?.players || {};

    return (
        <div className="tournament-info-players">
            <ul className="tournament-info-players--content">
                <li className="tournament-info-players--header">
                        <span>{t('tournament.place')}</span>
                        <span>ID</span>
                </li>
                {
                    Object.values(participants)?.sort((p1, p2) => {
                        if (selectedTournament?.info?.status === "FINISHED"){
                            return p1.place - p2.place
                        }
                        else {
                            if (p1.status === 'PROGRESS' && p2.status !== 'PROGRESS') {
                                return -1; // "progress" should come first
                            }
                            if (p1.status !== 'PROGRESS' && p2.status === 'PROGRESS') {
                                return 1; // "progress" should come first
                            }
                            return 0; // No change in order if both are the same
                        }
                    })?.map((item, index) => {
                        return <TournamentParticipantItem
                            key={index}
                            item={item}
                        />
                    })
                }
            </ul>
        </div>
    )
}

export default TournamentParticipants